module.exports = __webpack_public_path__ + "img/skroutz_smart_cart.5339e89a.png";